/* eslint-disable import/order */
/* eslint-disable import/no-dynamic-require */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import colors from '~/constants/colors';
import theme from '~/constants/theme';
import { useDirection } from '~/hooks/i18nHooks';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { DirectionProp } from '~/types/Direction';
import direction from '~/utils/direction';
import { Col, Row } from 'antd';
import InitialServicesCheckBox from '~/components/InitialServicesCheckBox';
import ImageServicesInitial from './ImageServicesInitial';

interface Props {
  inputKey: string;
  name: string;
  disabled?: boolean;
  key: string | number;
  longDescription: string;
  index?: any;
  type?: string;
  productKey?: any;
}

const InitialServicesCard: FC<Props> = (props) => {
  const { inputKey, disabled, name, longDescription, key, index, type, productKey } = props;
  const isMobile = useIsMobile();
  const { t } = useTranslation('fillApplication');
  const dir = useDirection();

  const checkbox = (
    <InitialServicesCheckBox
      productKey={productKey}
      type={type}
      index={index}
      key={key}
      inputKey={inputKey}
      disabled={disabled}
      name={name}
      withBorderBottom={false}
      longDescription={longDescription}
    />
  );

  return (
    <Container className="ServiceCard" disabled={disabled} dir={dir}>
      <Row>
        <Col span={6}>
          {' '}
          <ImageServicesInitial imageUrl={`../../../img/${inputKey}.png`} />
        </Col>
        <Col span={18}>{checkbox}</Col>
      </Row>
    </Container>
  );
};

interface ContainerProps extends DirectionProp {
  disabled?: boolean;
}

const Container = styled.div<ContainerProps>`
  border: solid 1px 1px 1px black;
  .imageContainer {
    border-radius: 12px;
    border: 1px solid var(--primary-grey-9, #cdcdce);
    padding: 10px;
  }
  cursor: pointer;
  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          cursor: default;
          opacity: 0.5;
        `
      : undefined}
  img {
    width: 80%;
  }
  .ServiceCard-Card {
    border-radius: ${theme.borderRadiusBase}px;
    transition: box-shadow 200ms;
    height: 100%;
    .ServiceCard-Content {
      /* display: none; */
      background-color: ${colors.componentBackground};
      border-radius: ${theme.borderRadiusBase}px;
      padding: 15px;
      .ServiceCard-Fee {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 8px;
        .AmountField {
          white-space: nowrap;
          ${direction.margin.left(8)};
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
        }
      }
      .ServiceCard-BottomText {
        font-size: 11px;
        line-height: 16px;
        margin-bottom: 8px;
      }
      .ServiceCard-BottomText3 {
        font-size: 14px;
        line-height: 22px;
        margin-top: 24px;
      }
    }
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    img {
      margin-top: 12px;
      width: 12vw;
    }
  }
`;

export default InitialServicesCard;
